import store from "../../../../../repository/store/store";
import { User } from "../../../../../../domain/entities/entities";
import { ExternalRoute, InternalRoute, MenuItem } from "./MenuItem";
import { currentDomain } from "../../../../../repository/http";
import { isDecolaTemplate, isGTopTemplate } from "../../../mixins";

/** Returns all the menu's items */
export const getMenuItems = (): MenuItem[] => {
  /** Contains current user's information. */
  const user = store.getters["userProfile_module/user"] as User;

  /** Dashboard item. */
  const dashboard = new MenuItem(
    "Início",
    "dashboard-icon.png",
    new InternalRoute("dashboard")
  );

  /** Statistics item. */
  const statistics = new MenuItem(
    "Meu dashboard",
    "dashboard-icon.png",
    new InternalRoute("statistics", { option: "chart" })
  );

  /** Shop item. */
  const shop = new MenuItem("Loja", "shop.png", new InternalRoute("shop"));

  /** Contains all the menu's items */
  const menuItems = [dashboard, statistics];

  /** Administrative panel item */
  const administrativePanel = new MenuItem(
    "Painel Admin.",
    "admin-icon.png",
    new ExternalRoute(currentDomain + "/admin#/dashboard", "_blank")
  );

  /** Manager panel item */
  const managerPanel = new MenuItem(
    "Meus times",
    "admin-icon.png",
    new ExternalRoute(currentDomain + "/admin#/team", "_blank")
  );

  switch (user.userType) {
    /** master and admin */
    case 2:
    case 5:
      menuItems.unshift(administrativePanel);
      break;
    /** manager */
    case 4:
      menuItems.unshift(managerPanel);
      break;
  }

  const hasCompany =
      Array.isArray(user.companies) &&
      user.companies.some(company => company.id > 0);

  if ((isDecolaTemplate() || isGTopTemplate()) && hasCompany) {
    menuItems.push(shop);
  }

  return menuItems;
};
